export const DEFAULT_FIFO_HYPERLINK = "See in Feedstock FIFO";
export const DEFAULT_HEADER_SUPPLIER = "Supplier";
export const DEFAULT_HEADER_SAP_CONTRACT_ITEM = "SAP contract number - item";
